module.exports = __webpack_public_path__ + "img/point_thum2_2.b5571091.png";